import styled from "styled-components";
import BaseInputLike from "../InputLike";

export const InputLike = styled(BaseInputLike)`
    cursor: text;
`;

export const Input = styled.input``;
